// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".enter-active[data-v-353dc18a],.leave-active[data-v-353dc18a]{overflow:hidden;-webkit-transition:height .3s ease;transition:height .3s ease}", ""]);
// Exports
module.exports = exports;
